
















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';

@Component({
  computed: {
    ...mapState('User', {
      businessGroups: 'businessGroups',
    }),
    ...mapState('Authorization', {
      keys: 'keys',
    }),
    ...mapState('Business', {
      allBusinesses: 'allBusinesses',
    }),
  },
})
export default class UserProfileBusinessList extends Vue {
  isLoading = false;
  reload = 0;

  total = 0;
  businesses = [];
  options = {
    itemsPerPage: 10,
    page: 1,
  };
  headers = [
    {
      text: 'Business',
      sortable: false,
      value: 'business.name',
    },
    {
      text: 'Group',
      sortable: false,
      value: 'group.name',
    },
    {
      text: 'Action',
      value: 'actions',
      sortable: false,
    },
  ];

  businessGroupIdLocal = null;
  businessOidLocal = null;

  showUpdateBusiness = false;
  updateBusinessOid: string | null = null;

  keys!: { id: number; groups: { id: number }[] }[];
  showKeyIds: number[] = [];

  async mounted() {
    // await this.fetchBusinessList()
  }

  fetchBusinessList() {
    this.isLoading = true;
    // const { page, itemsPerPage } = this.options
    this.$store
      .dispatch('User/fetchBusinessList', {
        id: this.$route.params.userId,
        params: {
          page: this.options.page,
          per_page: this.options.itemsPerPage,
          expand: ['group'],
        },
      })
      .then((response) => {
        if (response.data.code === 'fetched') {
          this.businesses = response.data.data.data;
          this.total = response.data.data.total;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  @Watch('options', { deep: true })
  watchOptions() {
    this.fetchBusinessList();
  }

  @Watch('businessGroupIdLocal')
  watchBusinessGroupIdLocal(v) {
    if (v) {
      const keys = this.keys.filter(
        (key) => !_.isEmpty(key.groups.find((group) => group.id === v))
      );

      this.showKeyIds = _.map(keys, 'id');
    } else {
      this.showKeyIds = [];
    }
  }

  toBusiness(oid) {
    this.$router.push({
      name: 'administrator-business-update',
      params: {
        businessOid: oid,
      },
    });
  }

  deleteBusiness(businessOid) {
    this.isLoading = true;

    this.$store
      .dispatch('User/deleteBusiness', {
        id: this.$route.params.userId,
        business_oid: businessOid,
      })
      .then(() => {
        this.reload++;
      });
  }

  editBusiness(businessOid, groupId) {
    this.businessOidLocal = businessOid;
    this.businessGroupIdLocal = groupId;
    this.showUpdateBusiness = true;
  }

  addBusiness() {
    this.businessOidLocal = null;
    this.businessGroupIdLocal = null;
    this.showUpdateBusiness = true;
  }

  updateBusiness() {
    this.isLoading = true;

    this.$store
      .dispatch('User/updateBusiness', {
        id: this.$route.params.userId,
        business_oid: this.businessOidLocal,
        group_id: this.businessGroupIdLocal,
      })
      .then(() => {
        this.reload++;
        this.showUpdateBusiness = false;
      });
  }
}
